/*
 *
 *
 * (c) 2017/8/4 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import ExecService from './exec-service.js';

export default new ExecService();



// WEBPACK FOOTER //
// ./src/lib/client-api/exec/index.js